// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__dEc6d","col":"styles_col__3vN58"};